<ng-container [formGroup]="addressForm">
    <h3 class="form-header" mat-dialog-title *ngIf="!data" i18n="@@81cce75e0f9b012a41d1df3e86e1a60ac87753e3" t="81cce75e0f9b012a41d1df3e86e1a60ac87753e3">Add Address</h3>
    <h3 class="form-header" mat-dialog-title *ngIf="data" i18n="@@09f19a1d7e6de05e08a73d9910ec74a45f9a611e" t="09f19a1d7e6de05e08a73d9910ec74a45f9a611e">Edit Address</h3>

    <div class="grid">

        <!-- Purpose and Country -->
        <div class="row">
            <div fxFlex="50" style="padding-left: 10px;">
                <tsl-label i18n="@@b6377d4b6187acc8cc2a700e923fa811d7e777d3" t="b6377d4b6187acc8cc2a700e923fa811d7e777d3">Purpose</tsl-label>
                <h3>{{AddressformControls.purpose.value?.name}}</h3>
            </div>
            <div fxFlex="50" *ngIf="AddressformControls.purpose.value?.id">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@a43f25a9ac40e8e2441ff0be7a36b8e5d15534df" t="a43f25a9ac40e8e2441ff0be7a36b8e5d15534df">Country</tsl-label>
                    <tsl-select triggerIcon="location_on" formControlName="country" required (selectionChange)="updateStateValidation($event)">
                        <tsl-option *ngFor="let country of countries" [value]="country.abbreviation">
                            {{ translateService.get(country.name) }}
                        </tsl-option>
                    </tsl-select>
                    <tsl-error
                        *ngIf="AddressformControls.country.errors && (AddressformControls.country.dirty || AddressformControls.country.touched)">
                        <span i18n="@@d848559f57496d74f23fe21030bec8a86b288032" t="d848559f57496d74f23fe21030bec8a86b288032">Country is Required</span>
                    </tsl-error>
                </tsl-form-field>
            </div>
        </div>

        <!-- Location Name -->
        <div class="row" *ngIf="AddressformControls.purpose.value?.id && AddressformControls.purpose.value?.id === 3">
            <div fxFlex="50">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@ed31c09fd77c36238c13d83635f3fe5294c733d2" t="ed31c09fd77c36238c13d83635f3fe5294c733d2">Location</tsl-label>
                    <input tslInput fullWidth maxlength="50" formControlName="location" name="txtLocation1" />
                    <tsl-hint align="below" class="max-length-hint">{{addressForm.get('location').value?.length || 0}} /
                        50</tsl-hint>
                    <tsl-error
                        *ngIf="AddressformControls.location.errors && (AddressformControls.location.dirty || AddressformControls.location.touched)">
                        <span i18n="@@bf390eb9c62fed91d148538dffc37583439f243d" t="bf390eb9c62fed91d148538dffc37583439f243d"> Location is Required </span>
                    </tsl-error>
                </tsl-form-field>
            </div>
        </div>

        <!-- Address/Street fields -->
        <div class="row" *ngIf="AddressformControls.purpose.value?.id">
            <div fxFlex="50">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@641a8b0ef24fdf3bb3b7c0cbe0af16b6ffa1cfdd" t="641a8b0ef24fdf3bb3b7c0cbe0af16b6ffa1cfdd">Street Address Line 1</tsl-label>
                    <input tslInput fullWidth maxlength="50" formControlName="street1" name="txtStreet1" />
                    <tsl-hint align="below" class="max-length-hint">{{addressForm.get('street1').value?.length || 0}} /
                        50</tsl-hint>
                    <tsl-error
                        *ngIf="AddressformControls.street1.errors && (AddressformControls.street1.dirty || AddressformControls.street1.touched)">
                        <span i18n="@@6653e5f2c38e2b52bd36a4796b3043464b017bb9" t="6653e5f2c38e2b52bd36a4796b3043464b017bb9"> Address is Required </span>
                    </tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="50">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@34331a1739d6ada6b8a0132434e61d42bc93a46e" t="34331a1739d6ada6b8a0132434e61d42bc93a46e">Street Address Line 2</tsl-label>
                    <input id="street2" tslInput fullWidth maxlength="50" formControlName="street2" />
                    <tsl-hint align="below" class="max-length-hint">{{addressForm.get('street2').value?.length || 0}} /
                        50
                    </tsl-hint>
                </tsl-form-field>
            </div>
        </div>

        <!-- City and State -->
        <div class="row" *ngIf="AddressformControls.purpose.value?.id">
            <div fxFlex="50">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@5c7012b5a926b32d9e45fefdcc8a1a3cb6f023d0" t="5c7012b5a926b32d9e45fefdcc8a1a3cb6f023d0">City</tsl-label>
                    <input id="city" tslInput type="text" fullWidth maxlength="30" formControlName="city" />
                    <tsl-hint align="below" class="max-length-hint">{{addressForm.get('city').value?.length || 0}} / 30
                    </tsl-hint>
                    <tsl-error
                        *ngIf="AddressformControls.city.errors && (AddressformControls.city.dirty || AddressformControls.city.touched)">
                        <span i18n="@@b1ceb2848a433a9e3d3d201889b9da60d59648e2" t="b1ceb2848a433a9e3d3d201889b9da60d59648e2">City is Required </span>
                    </tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="50">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@873b72903b1858a9cd6c8967521030b4d7d1435b" t="873b72903b1858a9cd6c8967521030b4d7d1435b">State</tsl-label>
                    <input id="state" tslInput fullWidth maxlength="30" formControlName="state" />
                    <tsl-hint align="below" class="max-length-hint">{{addressForm.get('state').value?.length || 0}} / 30
                    </tsl-hint>
                    <mat-error *ngIf="AddressformControls.state.dirty || AddressformControls.state.touched">
                        <span i18n="@@eb5e63d466a879c0da4d461c29d36c97fc78cf30" t="eb5e63d466a879c0da4d461c29d36c97fc78cf30" *ngIf="AddressformControls.state.hasError('required')">State is Required </span>
                        <span i18n="@@usstatevalidationMessage" t="usstatevalidationMessage" *ngIf="AddressformControls.state.hasError('invalidFormat')">For country USA, State should be of 2 capital character abbreviation</span>
                        <span i18n="@@notavalidnameforusastates" t="notavalidnameforusastates" *ngIf="AddressformControls.state.hasError('invalidState')">Not a valid State Name for Country USA.</span>
                      </mat-error>
                </tsl-form-field>
            </div>
        </div>

        <!-- Zipcode and Comments -->
        <div class="row" *ngIf="AddressformControls.purpose.value?.id">
            <div fxFlex="50">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@73f71f6be8e257467172f45a9e44934f979074e7" t="73f71f6be8e257467172f45a9e44934f979074e7">Zip/Postal Code</tsl-label>
                    <input id="zipCode" tslInput type="text" fullWidth maxlength="10" formControlName="zipCode" />
                    <tsl-hint align="below" class="max-length-hint">{{addressForm.get('zipCode').value?.length || 0}} /
                        10</tsl-hint>
                    <tsl-error
                        *ngIf="AddressformControls.zipCode.errors && (AddressformControls.zipCode.dirty || AddressformControls.zipCode.touched)">
                        <span i18n="@@65048901e11b03cb13a6e3e276b661c0765cd3fe" t="65048901e11b03cb13a6e3e276b661c0765cd3fe">Zip Code is Required </span>
                    </tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="50" *ngIf="AddressformControls.purpose.value?.id !== 3">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@c5bb9f8936cb33db2ca351a1b87a984fdf11917c" t="c5bb9f8936cb33db2ca351a1b87a984fdf11917c">Comments</tsl-label>
                    <input id="comments" tslInput fullWidth maxlength="100" formControlName="comments" />
                    <tsl-hint align="below" class="max-length-hint">{{addressForm.get('comments').value?.length || 0}} /
                        100</tsl-hint>
                </tsl-form-field>
            </div>
        </div>
    </div>



    <div class="grid" *ngIf="(AddressformControls.purpose.value?.id && AddressformControls.purpose.value?.id === 1)">
        <div class="row">
            <div fxFlex="10">
                <tsl-label class="documents" i18n="@@9d51b3c90afda70700229d1b8a55371c13cb3bce" t="9d51b3c90afda70700229d1b8a55371c13cb3bce">Documents</tsl-label>
            </div>
            <div fxFlex="90">
                <button matTooltip="Add Document" (click)="onDocumentAdding()" tsl-button size="small" color="black"
                    outline i18n="@@6b8edb53d6eaf3b3e9f95c6face89c58281d1390" t="6b8edb53d6eaf3b3e9f95c6face89c58281d1390" i18n-matTooltip>
                    Add Document
                </button>
            </div>

        </div>
        <div class="row" *ngIf="isDocumentAdding">
            <div fxFlex>
                <tsl-file-drop [inputText]="translateService.get('choose a file')" [hintText]="translateService.get('Drag and Drop a File or ')" #fileDrop [accept]="getAcceptedFormat" (fileChange)="onFileAdd($event)">
                </tsl-file-drop>
            </div>
        </div>
        <div class="row" style="padding-bottom:10px;">
            <div class="column" fxFlex="40">
                <tsl-label class="label" i18n="@@374fa86a4b3f1afa8e652b516dd7fecb4f4a207d" t="374fa86a4b3f1afa8e652b516dd7fecb4f4a207d">Document</tsl-label>
            </div>
            <div class="column" fxFlex="30">
                <tsl-label class="label" i18n="@@f0e56bb50e6ed6836e87d78d254177da229a07d1" t="f0e56bb50e6ed6836e87d78d254177da229a07d1">Effective Date</tsl-label>
            </div>
            <div class="column" fxFlex="30">
                <tsl-label class="label" i18n="@@41d055ec9cef3afb116c3118c2244ee66c895fbb" t="41d055ec9cef3afb116c3118c2244ee66c895fbb">Expiration Date</tsl-label>
            </div>
        </div>
        <!-- Zipcode and Comments -->
        <div class="row" *ngIf="documents">
            <div class="row" formArrayName="documents" *ngFor="let doc of documents['controls']; let i = index;">
                <div class="row" [formGroupName]="i">
                    <div fxFlex="40">
                        <tsl-label class="label">{{doc.get('fileName').value}}</tsl-label>
                        <button *ngIf="!doc.get('documentId').value" (click)="removeFile(i)" tsl-icon-button>
                            <tsl-icon>delete</tsl-icon>
                        </button>
                    </div>
                    <div fxFlex="30">
                        <tsl-form-field fxFlex="90">
                            <tsl-datepicker singleSelection required formControlName="effectiveDate" [selectYear]="true" [readonly]="true">
                            </tsl-datepicker>
                            <tsl-error i18n="@@e5f24fc7a2bf50bd61d109dd9cad3fbff6ec7add" t="e5f24fc7a2bf50bd61d109dd9cad3fbff6ec7add">Required</tsl-error>
                        </tsl-form-field>
                    </div>
                    <div fxFlex="30">
                        <tsl-form-field fxFlex="90">
                            <tsl-datepicker singleSelection required formControlName="expirationDate" [selectYear]="true" [readonly]="true">
                            </tsl-datepicker>
                            <tsl-error i18n="@@e5f24fc7a2bf50bd61d109dd9cad3fbff6ec7add" t="e5f24fc7a2bf50bd61d109dd9cad3fbff6ec7add">Required</tsl-error>
                        </tsl-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <br>

    <!-- Action Buttons -->
    <div class="right">
        <button tsl-button size="small" color="black" outline (click)="onClose()" i18n="@@d7b35c384aecd25a516200d6921836374613dfe7" t="d7b35c384aecd25a516200d6921836374613dfe7">Cancel</button>
        <button tsl-button size="small" color="blue" filled [disabled]="addressForm.invalid"
            (click)="save()" i18n="@@52c9a103b812f258bcddc3d90a6e3f46871d25fe" t="52c9a103b812f258bcddc3d90a6e3f46871d25fe">Save</button>
    </div>
</ng-container>